import { isExternalLink } from './externalLink';

const LOGIN_PATH = '/login';

/** 详情地址：外链取 linkUrl；子站点 /{companyId}/notice/{id}.html（companyId 为 1 或非纯数字回落主站） */
export function buildNoticeDetailHref(item: any): string {
	if (isExternalLink(item)) return item.linkUrl;

	const id = item?.announcementId ?? item?.informationId ?? item?.id;
	if (!id) return '#';

	const companyId = String(item?.companyId ?? '');
	if (/^\d+$/.test(companyId) && Number(companyId) !== 1) {
		return `/${companyId}/notice/${id}.html`;
	}
	return `/notice/${id}.html`;
}

/** 是否国械智造内容：needLogin 字段只有国械智造的数据会返回 */
export function isGxzzNotice(item: any): boolean {
	return item?.needLogin !== undefined && item?.needLogin !== null && item?.needLogin !== '';
}

/** 是否需要登录：总站否；质量公告子站是；国械智造头条按 needLogin；其它子站是 */
export function isNoticeLoginRequired(item: any, { isGxzz = false, isQuantity = false } = {}): boolean {
	const companyId = String(item?.companyId ?? '');
	if (!/^\d+$/.test(companyId) || Number(companyId) === 1) return false;

	if (isQuantity) return true;

	if (isGxzz || isGxzzNotice(item)) return Number(item?.needLogin) === 1;

	return true;
}

/** 登录页地址：带 redirect，登录成功后回到指定地址 */
export function buildLoginHref(redirect: string): string {
	return `${LOGIN_PATH}?redirect=${encodeURIComponent(redirect)}`;
}

/** 列表项 href：需登录且未登录 → 登录页，其余 → 详情地址（登录态由组件用 cookie 判定后传入） */
export function buildNoticeItemHref(item: any, { loggedIn = false, isGxzz = false, isQuantity = false } = {}): string {
	if (isNoticeLoginRequired(item, { isGxzz, isQuantity }) && !loggedIn) {
		return buildLoginHref(buildNoticeDetailHref(item));
	}

	return buildNoticeDetailHref(item);
}

export default buildNoticeDetailHref;
